import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from './closeIcon';

const CloseButton = ({className, onClose, color, width, height}) => {
  return (
    <button type="button" className={className} onClick={onClose} color={color} width={width} height={height}>
      <CloseIcon color={color} width={width} height={height} />
    </button>
  );
};

CloseButton.propTypes = {
  /** The function to close the tooltip. */
  onClose: PropTypes.func.isRequired,

  /** The class name of the close button. */
  className: PropTypes.string,

  /** The color of the close button. */
  color: PropTypes.string,

  /** The width of the close button. */
  width: PropTypes.string,

  /** The height of the close button. */
  height: PropTypes.string,
};

CloseButton.defaultProps = {
  className: 'closeButton',
  color: '#2f343b',
  width: '12px',
  height: '12px',
};

export default CloseButton;
